import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col, Form, Button } from 'antd'
import OtpInput from 'react-otp-input'

import Timer from 'components/Timer'

import { BUTTONS, LOGIN_PAGE } from '../../../../../../constants/constants'
import { useActions } from '../../../../../hooks/useActions'
import { changeRoute, verifyAuthData, changeTab, removeNotification, verifyPasswordChangeData } from 'store/actions/login'
import { secureLocalStorageGet } from '../../../../../helpers'

import '../sidebar.scss'
import './index.scss'
import { useTranslation } from 'react-i18next'

const MessageInput: React.FC = ({errorMessage, notifyData}) => {
  const {t} = useTranslation();

  const { changeRoute, verifyAuthData, changeTab, removeNotification, verifyPasswordChangeData } = useActions()
  const [form] = Form.useForm()
  const history = useHistory()
  const inputRef = useRef<OtpInput>(null)

  const handleChangeRoute = () => {
    changeRoute(0)
    changeTab('2')
  }

  const handleInput = () => {
    // verifyAuthData(value, history)
    if (!localStorage.getItem('verify')) {
      verifyAuthData(value, history)
    } else {
      let verifyData = {
        userName: secureLocalStorageGet("username"),
        verfication: value
      }
      verifyPasswordChangeData(verifyData, history)
    }
  }
  const [value, setValue] = useState<number[]>([])

  const handleValue = (value: any) => {
    setValue(value)
  }
  const resetForm = () => {
    // inputRef.current.__clearvalues__()
    removeNotification()
    changeRoute(0)
    changeTab(2)
  }
  const closeNotification = () => {
    removeNotification()
 }
  return (
    <Row>
      {/* {errorMessage && notifyData && <CustomNotifocation message={errorMessage[0].MESSAGE}/> } */}
      <Col className="login-form">
        <h3>{t(LOGIN_PAGE.ENTER_PASSWORD)}</h3>
        <Form
          form={form}
          onSubmit={(e: any) => e.preventDefault()}
          onFinish={handleInput}
          onBlur={closeNotification}
          shouldAutoFocus={true}
          autoComplete="off"
          className="message-input-form"
        >
          {/* <ReactCodeInput
            onChange={handleValue}
            type="number"
            ref= {inputRef}
            values={value}
            className='message-input-form__input'
            fields={6}
          /> */}
          <OtpInput
            value={value}
            onChange={handleValue}
            numInputs={6}
            inputStyle='otpInput'
            isInputNum={true}
            shouldAutoFocus={true}
            className='message-input-form__input'
          />
          <ul className="message-form__details">
            <li className="message-form__time" >
              { value ? <Timer timerEnd={resetForm} /> : <span>00:00</span> }
            </li>
          </ul>
          <div className="login-form__buttons">
            <Row>
              <Button
                size={'large'}
                className="prev"
                onClick={handleChangeRoute}
              >
                {BUTTONS.BACK_BUTTON}
              </Button>
              <Button size={'large'} className="next blue" htmlType="submit">
                {BUTTONS.NEXT_BUTTON}
              </Button>
            </Row>
          </div>
        </Form>
      </Col>
    </Row>
  )
}

const mapDispatchToProps = { verifyAuthData, changeRoute, changeTab, removeNotification, verifyPasswordChangeData }

const mapStateToProps = (state: any) => ({
  notifyData: state.googleAuth.notify,
  errorMessage: state.googleAuth.error ? state.googleAuth.error.messages : ''
})
export default connect(mapStateToProps, mapDispatchToProps)(MessageInput)
